import cx from 'classnames';
import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';


import PartEstimationForm from './part-estimation-form';
import FirstScreenBanner from './part-first-screen-banner';
import PartFooter from './part-footer';
import PartHeader from './part-header';

import styles from './page-thanks.module.scss';

export default function PageThanks() {
  const [showBlock, setShowBlock] = useState(false);

  useEffect(() => {
    const toggleFloatingButton = () => {
      const floatingButton = document.getElementById('floating-button');
      const endFormElement = document.getElementsByName('end-form')[0];

      if (floatingButton && endFormElement) {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;

        // Adjust the scroll position threshold as needed
        const threshold = endFormElement.offsetTop;
        if (scrollPosition > threshold) {
          setShowBlock(true);
        } else {
          setShowBlock(false);
        }
      }
    };

    window.addEventListener('scroll', toggleFloatingButton);

    return () => window.removeEventListener('scroll', toggleFloatingButton);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.headerContainer}>
        <PartHeader />
      </div>
      <div className={styles.firstScreenBannerContainer}>
        <FirstScreenBanner />
      </div>
      <div id="estimationForm" className={styles.formContainer}>
        <PartEstimationForm />
        <div name="end-form" />
      </div>
     <PartFooter />
   </div>
  );
}
